import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListEventExtras {
	uriParams: Api.Operations['listEventExtras']['parameters']['path']
	params?: Api.Operations['listEventExtras']['parameters']['query']
	response: Api.Operations['listEventExtras']['responses']['200']['content']['application/json']
}

export const listEventExtras = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListEventExtras>(
		{
			method: 'get',
			url: '/events/{eventId}/extras',
			...overideConfig,
		},
		axiosInstance,
	)
